"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const gcpApi = Yup.object().shape({
  module: Yup.string().required(),
  service: Yup.string().required(),
  method: Yup.string().required(),
  params: Yup.mixed().required()
});
const addonSchema = Yup.object()
  .shape({
    addOns: Yup.array()
      .of(gcpApi)
      .nullable()
  })
  .required();
const objectSchema = gcpApi.concat(addonSchema).required();
class GCPResourceNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: objectSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.GCPResourceNodeValidation = GCPResourceNodeValidation;
//# sourceMappingURL=GCPResourceNodeValidation.js.map
